import React, {
  useCallback,
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from "react";
import {
  DropZone,
  Stack,
  FormLayout,
  TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Button,
  Text,
  Loading,
  ChoiceList,
  Select,
  ButtonGroup,
  Modal,
  TextContainer,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import { NoteMinor } from "@shopify/polaris-icons";
import { Editor } from "@tinymce/tinymce-react";
import { LanguageMinor } from "@shopify/polaris-icons";
import { filter } from "domutils";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import EditorTiny from "./EditorTiny";
import axiosDefault from "axios";
import LoadingScreen from "../Components/LoadingScreen";
import AsyncSelect from "react-select/async";
import JoditEditor from "jodit-react";
import JoditEditorComponent from "./JoditEditor";

const ListItemEdit = forwardRef((props, ref) => {
  const [isSaving, setIsSaving] = useState(false);
  const refId = useRef(null);
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  let object = JSON.parse(props.object);
  const [data, setData] = useState([]);
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitle = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeSubtitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, subtitle: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, text: value };
      }
      return obj;
    });
    setData(newState);
  };
  const optionsPosition = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" },
  ];
  const handleSelectChangeImagePosition = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return {
          ...obj,
          imagePosition: value,
        };
      }
      return obj;
    });
    setData(newState);
    //setImagePositionError("");
  };
  const [imagePositionError, setImagePositionError] = useState("");
  const handleChangeCtaText = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLink = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeCtaLinkTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaLink: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeTitleTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, title: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeCtaTextTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, ctaText: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChange = (newChecked) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, active: newChecked };
      }
      return obj;
    });
    setData(newState);
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs,webp, svgs and jsons"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(file[file.length - 1].type) > 0
                  ? window.URL.createObjectURL(file[file.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileTranslated, setFileTranslated] = useState();
  const handleDropZoneDropTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslated((fileTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadTranslated = !fileTranslated && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs,svgs,webp and jsons"}
    />
  );
  const uploadedFileTranslated = fileTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div>
        {fileTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageTranslated = (fileTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("image[en]", fileTranslated[fileTranslated.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImage: imageKey.current,
              image:
                validImageTypes.indexOf(
                  fileTranslated[fileTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslated[fileTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMobile, setFileMobile] = useState();
  const handleDropZoneDropMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMobile((fileMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadMobile = !fileMobile && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs,webp, svgs and jsons"}
    />
  );
  const uploadedFileMobile = fileMobile && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div>
        {fileMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMobile.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImageMobile = (fileMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("mobile_image[en]", fileMobile[fileMobile.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              fileImageMobile: imageKey.current,
              mobileImage:
                validImageTypes.indexOf(
                  fileMobile[fileMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMobile[fileMobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileTranslatedMobile, setFileTranslatedMobile] = useState();
  const handleDropZoneDropTranslatedMobile = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileTranslatedMobile((fileTranslatedMobile) => acceptedFiles[0]),
    []
  );

  const fileUploadTranslatedMobile = !fileTranslatedMobile && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs,svgs,webp and jsons"}
    />
  );
  const uploadedFileTranslatedMobile = fileTranslatedMobile && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div>
        {fileTranslatedMobile.name}{" "}
        <Text variant="bodySm" as="p">
          {fileTranslatedMobile.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageTranslatedMobile = (fileTranslatedMobile) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append(
      "mobile_image[en]",
      fileTranslatedMobile[fileTranslatedMobile.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              fileImageMobile: imageKey.current,
              mobileImage:
                validImageTypes.indexOf(
                  fileTranslatedMobile[fileTranslatedMobile.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileTranslatedMobile[fileTranslatedMobile.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  useEffect(() => {
    object = JSON.parse(props.object);
    console.log("objectt=", object);
    setData(
      props.languagesArray
        .concat([{ label: "English", value: "en" }])
        .map((element, index) => {
          return {
            language: element.value,
            title:
              object?.title && object?.title[element.value]
                ? object?.title[element.value]
                : "",
            subtitle:
              object?.title && object?.subtitle[element.value]
                ? object?.subtitle[element.value]
                : "",
            text:
              object?.title && object?.text[element.value]
                ? object?.text[element.value]
                : "",
            ctaLinkType:
              object?.cta_link_type !== null
                ? String(object?.cta_link_type)
                : "",
            ctaText:
              object?.cta_text && object?.cta_text[element.value]
                ? object?.cta_text[element.value]
                : "",
            ctaLink:
              object?.cta_link && object?.cta_link[element.value]
                ? object?.cta_link[element.value]
                : "",
            ctaLinkPage: object?.cta_page_alias ? object?.cta_page_alias : "",
            ctaLinkBlog: object?.cta_blog_alias ? object?.cta_blog_alias : "",
            ctaLinkCollection: {
              label: object?.cta_shopify_collection_title
                ? object?.cta_shopify_collection_title
                : "",
              value: object?.cta_shopify_collection_id
                ? object.cta_shopify_collection_id
                : "",
              handle: object?.cta_shopify_collection_handle
                ? object?.cta_shopify_collection_handle
                : "",
            },

            ctaLinkProduct: {
              label: object?.cta_shopify_product_title
                ? object?.cta_shopify_product_title
                : "",
              value: object?.cta_shopify_product_id
                ? object?.cta_shopify_product_id
                : "",
              handle:
                object?.details && object?.details?.cta_shopify_product_handle
                  ? object?.details?.cta_shopify_product_handle
                  : "",
            },
            ctaLink:
              object?.cta_link && object?.cta_link[element.value]
                ? object?.cta_link[element.value]
                : "",
            image:
              object?.image && object?.image[element.value]
                ? object?.image[element.value]
                : "",
            imagePosition: object?.image_position ? object?.image_position : "",
            mobileImage:
              object?.mobile_image && object?.mobile_image[element.value]
                ? getFileExtension(object?.mobile_image[element.value]) ===
                  "svg"
                  ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                  : object?.mobile_image[element.value]
                : "",
            fileImage: "",
            fileImageMobile: "",
            active: object?.is_active ? true : false,
            vimeoId:
              object?.vimeo_id && object?.vimeo_id[element.value]
                ? object?.vimeo_id[element.value]
                : "",
            youtubeId:
              object?.youtube_id && object?.youtube_id[element.value]
                ? object?.youtube_id[element.value]
                : "",
            link_mp4:
              object?.link_mp4 && object?.link_mp4[element.value]
                ? object?.link_mp4[element.value]
                : "",
            vimeo_id:
              object?.vimeo_id && object?.vimeo_id[element.value]
                ? object?.vimeo_id[element.value]
                : "",
            link_ogg:
              object?.link_ogg && object?.link_ogg[element.value]
                ? object?.link_ogg[element.value]
                : "",
            link_webm:
              object?.link_webm && object?.link_webm[element.value]
                ? object?.link_webm[element.value]
                : "",
            video_mp4: "",
            video_ogg: "",
            video_webm: "",
            image_mp4:
              object?.file_mp4 && object?.file_mp4[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_ogg:
              object?.file_ogg && object?.file_ogg[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            image_webm:
              object?.file_webm && object?.file_webm[element.value]
                ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
                : "",
            file_pdf: "",
            image_filepdf: object?.document
              ? "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304"
              : "",
          };
        })
    );
  }, []);

  useImperativeHandle(ref, () => ({
    handleSave() {
      props.showSaving();
      console.log("dataaaa=", data);
      const form_data = new FormData();
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkType &&
        form_data.append(
          `cta_link_type`,
          findArrayElementByLanguage(data, "en") &&
            findArrayElementByLanguage(data, "en").ctaLinkType
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkPage !== null &&
        form_data.append(
          `cta_page_alias`,
          findArrayElementByLanguage(data, "en").ctaLinkPage
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkBlog !== null &&
        form_data.append(
          `cta_blog_alias`,
          findArrayElementByLanguage(data, "en").ctaLinkBlog
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkCollection &&
        form_data.append(
          `cta_shopify_collection_id`,
          findArrayElementByLanguage(data, "en").ctaLinkCollection.value
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkProduct &&
        form_data.append(
          `cta_shopify_product_id`,
          findArrayElementByLanguage(data, "en").ctaLinkProduct.value
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkCollection &&
        form_data.append(
          `cta_shopify_collection_title`,
          findArrayElementByLanguage(data, "en").ctaLinkCollection.label
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkProduct &&
        form_data.append(
          `cta_shopify_product_title`,
          findArrayElementByLanguage(data, "en").ctaLinkProduct.label
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkCollection &&
        form_data.append(
          `cta_shopify_collection_handle`,
          findArrayElementByLanguage(data, "en").ctaLinkCollection.handle
        );
      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").ctaLinkProduct &&
        form_data.append(
          `cta_shopify_product_handle`,
          findArrayElementByLanguage(data, "en").ctaLinkProduct.handle
        );
      data.forEach((selected, index) =>
        form_data.append(`cta_link[${selected.language}]`, selected.ctaLink)
      );
      data.forEach((selected, index) =>
        form_data.append(`title[${selected.language}]`, selected.title)
      );
      data.forEach((selected, index) =>
        form_data.append(`subtitle[${selected.language}]`, selected.subtitle)
      );
      data.forEach((selected, index) =>
        form_data.append(`text[${selected.language}]`, selected.text)
      );
      data.forEach((selected, index) =>
        form_data.append(`cta_text[${selected.language}]`, selected.ctaText)
      );
      form_data.append("is_active", data[data.length - 1].active ? 1 : 0);
      data.forEach((selected, index) =>
        form_data.append(`image[${selected.language}]`, selected.fileImage)
      );
      data.forEach((selected, index) =>
        form_data.append(
          `mobile_image[${selected.language}]`,
          selected.fileImageMobile
        )
      );
      data.forEach(
        (selected, index) =>
          selected.video_mp4 &&
          form_data.append(`file_mp4[${selected.language}]`, selected.video_mp4)
      );
      data.forEach(
        (selected, index) =>
          selected.video_ogg &&
          form_data.append(`file_ogg[${selected.language}]`, selected.video_ogg)
      );
      data.forEach(
        (selected, index) =>
          selected.video_webm &&
          form_data.append(
            `file_webm[${selected.language}]`,
            selected.video_webm
          )
      );

      findArrayElementByLanguage(data, "en") &&
        findArrayElementByLanguage(data, "en").file_pdf &&
        form_data.append(
          "file_pdf",
          findArrayElementByLanguage(data, "en").file_pdf
        );

      data.forEach((selected, index) =>
        form_data.append(`link_mp4[${selected.language}]`, selected.link_mp4)
      );
      data.forEach((selected, index) =>
        form_data.append(`link_ogg[${selected.language}]`, selected.link_ogg)
      );
      data.forEach((selected, index) =>
        form_data.append(`link_webm[${selected.language}]`, selected.link_webm)
      );
      data.forEach((selected, index) =>
        form_data.append(`vimeo_id[${selected.language}]`, selected.vimeo_id)
      );
      data[data.length - 1].imagePosition &&
        form_data.append("image_position", data[data.length - 1].imagePosition);
      form_data.append("_method", "PATCH");
      axios
        .post(`/sections/${props.sectionId}/list/${object.id}`, form_data)
        .then((res) => {
          props.handleCloseModalEditItem();
          props.handleSaveAndRefresh();
          props?.refreshApi();
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActive();
            props.removeSaving();
          }
        });
    },
  }));
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This image have been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDeleteImage = (field, language) => {
    refId.current = field + ";" + language;
    console.log(field + ";" + language);
    setActiveDelete(true);
  };
  const handleDeleteImageMobile = (field, language) => {
    refId.current = field + ";" + language;
    console.log(field + ";" + language);
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("entity_type", "section");
    form_data.append("entity_id", props.sectionId);
    form_data.append("entity_item_id", object.id);
    form_data.append("field", refId.current.split(";")[0]);
    form_data.append("language_code", refId.current.split(";")[1]);
    axios
      .post(`/remove/image`, form_data)
      .then((result) => {
        setToastContent("This image have been successfully deleted");
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        const newState = data.map((obj) => {
          if (obj.language === refId.current.split(";")[1]) {
            if (refId.current.split(";")[0] === "image")
              return {
                ...obj,
                image: "",
              };
            else
              return {
                ...obj,
                mobileImage: "",
              };
          }
          return obj;
        });
        setData(newState);
        props.handleRefreshSections();
      })
      .catch((err) => console.log(err));
  };
  const handleSelectChangeCtaLinkType = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkType: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [optionsCtaLinkType, setOptionsCtaLinkType] = useState([
    { label: "External Link", value: "1" },
    { label: "Page", value: "2" },
    { label: "Blog", value: "3" },
    { label: "Shopify Product", value: "4" },
    { label: "Shopify Collection", value: "5" },
  ]);
  const [selectedPage, setSelectedPage] = useState("");
  const handleSelectChangePage = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkPage: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const handleSelectChangeBlog = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkBlog: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyCollection, setSelectedShopifyCollection] =
    useState("");
  const handleSelectChangeShopifyCollection = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkCollection: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [selectedShopifyProduct, setSelectedShopifyProduct] = useState("");
  const handleSelectChangeShopifyProduct = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, ctaLinkProduct: value };
      }
      return obj;
    });
    setData(newState);
    //setInputValueCollection("");
  };
  const [
    firstTimeLoadedCollectionsOptions,
    setFirstTimeLoadedCollectionsOptions,
  ] = useState([]);
  const loadOptionsCollections = (inputValue, callback) => {
    axios
      .get(`/shopify-collections?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedCollectionsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };
  const [firstTimeLoadedProductsOptions, setFirstTimeLoadedProductsOptions] =
    useState([]);
  const loadOptionsProducts = (inputValue, callback) => {
    axios
      .get(`/shopify-products?search=${inputValue}`)
      .then((result) => {
        setTimeout(() => {
          callback(
            result.data.data.map((item, index) => {
              return {
                label: item.title,
                value: String(item.id),
                handle: item.handle,
              };
            })
          );
        }, 0);
        setFirstTimeLoadedProductsOptions(
          result.data.data.map((item, index) => {
            return {
              label: item.title,
              value: String(item.id),
              handle: item.handle,
            };
          })
        );
      })
      .catch((err) => console.log(err));
  };

  const [fileMp4, setFileMp4] = useState();
  const handleDropZoneDropMp4 = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4((fileMp4) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4 = !fileMp4 && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4 = fileMp4 && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4.size} bytes
        </Text>
      </div>
    </Stack>
  );

  // const imageKey = useRef("");
  const sendFileMp4 = (fileMp4) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("video[en]", fileMp4[fileMp4.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_mp4: imageKey.current,
              image_mp4:
                validImageTypes.indexOf(fileMp4[fileMp4.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileMp4[fileMp4.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileMp4Translated, setFileMp4Translated] = useState();
  const handleDropZoneDropMp4Translated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileMp4Translated((fileMp4Translated) => acceptedFiles[0]),
    []
  );

  const fileUploadMp4Translated = !fileMp4Translated && (
    <DropZone.FileUpload actionHint={"Accepts mp4"} />
  );
  const uploadedFileMp4Translated = fileMp4Translated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileMp4Translated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileMp4Translated.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileMp4Translated = (fileMp4Translated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileMp4Translated[fileMp4Translated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_mp4: imageKey.current,
              image_mp4:
                validImageTypes.indexOf(
                  fileMp4Translated[fileMp4Translated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileMp4Translated[fileMp4Translated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOgg, setFileOgg] = useState();
  const handleDropZoneDropOgg = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOgg((fileOgg) => acceptedFiles[0]),
    []
  );

  const fileUploadOgg = !fileOgg && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOgg = fileOgg && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOgg.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOgg.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileOgg = (fileOgg) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("video[en]", fileOgg[fileOgg.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_ogg: imageKey.current,
              image_ogg:
                validImageTypes.indexOf(fileOgg[fileOgg.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileOgg[fileOgg.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileOggTranslated, setFileOggTranslated] = useState();
  const handleDropZoneDropOggTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileOggTranslated((fileOggTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadOggTranslated = !fileOggTranslated && (
    <DropZone.FileUpload actionHint={"Accepts ogg"} />
  );
  const uploadedFileOggTranslated = fileOggTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileOggTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileOggTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileOggTranslated = (fileOggTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileOggTranslated[fileOggTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_ogg: imageKey.current,
              image_ogg:
                validImageTypes.indexOf(
                  fileOggTranslated[fileOggTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileOggTranslated[fileOggTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebm, setFileWebm] = useState();
  const handleDropZoneDropWebm = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebm((fileWebm) => acceptedFiles[0]),
    []
  );

  const fileUploadWebm = !fileWebm && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebm = fileWebm && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebm.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebm.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileWebm = (fileWebm) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("video[en]", fileWebm[fileWebm.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              video_webm: imageKey.current,
              image_webm:
                validImageTypes.indexOf(fileWebm[fileWebm.length - 1].type) > 0
                  ? window.URL.createObjectURL(fileWebm[fileWebm.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [fileWebmTranslated, setFileWebmTranslated] = useState();
  const handleDropZoneDropWebmTranslated = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFileWebmTranslated((fileWebmTranslated) => acceptedFiles[0]),
    []
  );

  const fileUploadWebmTranslated = !fileWebmTranslated && (
    <DropZone.FileUpload actionHint={"Accepts webm"} />
  );
  const uploadedFileWebmTranslated = fileWebmTranslated && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {fileWebmTranslated.name}{" "}
        <Text variant="bodySm" as="p">
          {fileWebmTranslated.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFileWebmTranslated = (fileWebmTranslated) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append(
      `video[${selectedLanguage}]`,
      fileWebmTranslated[fileWebmTranslated.length - 1]
    );
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === selectedLanguage) {
            return {
              ...obj,
              video_webm: imageKey.current,
              image_webm:
                validImageTypes.indexOf(
                  fileWebmTranslated[fileWebmTranslated.length - 1].type
                ) > 0
                  ? window.URL.createObjectURL(
                      fileWebmTranslated[fileWebmTranslated.length - 1]
                    )
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };

  const [filePdf, setFiledPdf] = useState();
  const handleDropZoneDropFilePdf = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiledPdf((filePdf) => acceptedFiles[0]),
    []
  );

  const fileUploadPdf = !filePdf && (
    <DropZone.FileUpload actionHint={"Accepts pdf"} />
  );
  const uploadedFilePdf = filePdf && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div className="maxtextwidth">
        {filePdf.name}{" "}
        <Text variant="bodySm" as="p">
          {filePdf.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendFilePdf = (filePdf) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("document", filePdf[filePdf.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        const newState = data.map((obj) => {
          if (obj.language === "en") {
            return {
              ...obj,
              file_pdf: imageKey.current,
              image_filepdf:
                validImageTypes.indexOf(filePdf[filePdf.length - 1].type) > 0
                  ? window.URL.createObjectURL(filePdf[filePdf.length - 1])
                  : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
            };
          }
          return obj;
        });
        setData(newState);
      })
      .catch(function (error) {});
  };
  const handleChangeLinkMp4 = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_mp4: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkMp4Translated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_mp4: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkOgg = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_ogg: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkOggTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_ogg: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkWebm = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, link_webm: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeLinkWebmTranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, link_webm: value };
      }
      return obj;
    });
    setData(newState);
  };

  const handleChangeVimeoId = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === "en") {
        return { ...obj, vimeo_id: value };
      }
      return obj;
    });
    setData(newState);
  };
  const handleChangeVimeoIdranslated = (value) => {
    const newState = data.map((obj) => {
      if (obj.language === selectedLanguage) {
        return { ...obj, vimeo_id: value };
      }
      return obj;
    });
    setData(newState);
  };
  const getFileExtension = (url) => {
    return url.split(".").pop().split("?")[0];
  };
  return (
    <FormLayout>
      <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button>
          <Button
            plain
            onClick={handleTranslate}
            icon={!translatedButtonClicked ? LanguageMinor : ""}
          >
            {translatedButtonClicked ? "Edit English" : "Translate"}
          </Button>
        </ButtonGroup>
      </div>

      <table>
        <tbody>
          <tr>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            {translatedButtonClicked && (
              <th>
                <Select
                  options={props.languagesArray}
                  onChange={handleSelectChangeLanguage}
                  value={selectedLanguage}
                  placeholder="Please select a language"
                />
              </th>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Title
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").title
                }
                onChange={handleChangeTitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).title
                  }
                  onChange={handleChangeTitleTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Subtitle
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").subtitle
                }
                onChange={handleChangeSubtitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).subtitle
                  }
                  onChange={handleChangeSubtitleTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Text
              </Text>
            </td>
            <td>
              <JoditEditorComponent
                boolRichTextTools={boolRichTextTools}
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").text
                }
                handleChangeValue={handleChangeText}
                disabled={translatedButtonClicked}
                height={200}
              />
              {/* <Editor
                disabled={translatedButtonClicked}
                apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").text
                }
                init={{
                  readonly: 1,
                  branding: false,
                  height: 200,
                  menubar: false,
                  plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount",
                  ],
                  toolbar:
                    "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                }}
                onEditorChange={handleChangeText}
              /> */}
            </td>
            {translatedButtonClicked && (
              <td>
                <JoditEditorComponent
                  boolRichTextTools={boolRichTextTools}
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).text
                  }
                  handleChangeValue={handleChangeTextTranslated}
                  height={200}
                />
                {/* <Editor
                  apiKey="7e5qugyswmfji644700m0pos9pozwpesrtdbyflsqx2s0zsf"
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).text
                  }
                  init={{
                    readonly: 1,
                    branding: false,
                    height: 200,
                    menubar: false,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | bold italic backcolor | \
alignleft aligncenter alignright alignjustify | \
bullist numlist outdent indent | removeformat | help|code",
                  }}
                  onEditorChange={handleChangeTextTranslated}
                /> */}
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                CTA Text
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaText
                }
                onChange={handleChangeCtaText}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).ctaText
                  }
                  onChange={handleChangeCtaTextTranslated}
                />
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                CTA Link
              </Text>
            </td>

            <td className="rowDiv">
              <div style={{ width: "50%" }}>
                <Select
                  options={optionsCtaLinkType}
                  onChange={handleSelectChangeCtaLinkType}
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").ctaLinkType
                  }
                  // value={selectedCtaLinkType}
                  placeholder="Please select"
                />
              </div>
              <div style={{ width: "50%" }} className="ms-2">
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "1" && (
                    <TextField
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLink
                      }
                      onChange={handleChangeCtaLink}
                      disabled={translatedButtonClicked}
                    />
                  )}
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "4" && (
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={firstTimeLoadedProductsOptions}
                      loadOptions={loadOptionsProducts}
                      onChange={handleSelectChangeShopifyProduct}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkProduct
                      }
                    />
                    // <Autocomplete
                    //   options={optionsCollections}
                    //   selected={selectedOptions}
                    //   onSelect={updateSelection}
                    //   textField={textField}
                    // />
                  )}
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "5" && (
                    <AsyncSelect
                      cacheOptions
                      defaultOptions={firstTimeLoadedCollectionsOptions}
                      loadOptions={loadOptionsCollections}
                      onChange={handleSelectChangeShopifyCollection}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkCollection
                      }
                    />
                    // <Autocomplete
                    //   options={optionsCollections}
                    //   selected={selectedOptions}
                    //   onSelect={updateSelection}
                    //   textField={textField}
                    // />
                  )}

                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "2" && (
                    <Select
                      options={props.pagesArray}
                      onChange={handleSelectChangePage}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkPage
                      }
                      placeholder="Please select"
                    />
                  )}
                {findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").ctaLinkType ===
                    "3" && (
                    <Select
                      options={props.blogsArray}
                      onChange={handleSelectChangeBlog}
                      value={
                        findArrayElementByLanguage(data, "en") &&
                        findArrayElementByLanguage(data, "en").ctaLinkBlog
                      }
                      placeholder="Please select"
                    />
                  )}
              </div>
            </td>
            {translatedButtonClicked &&
              findArrayElementByLanguage(data, "en") &&
              findArrayElementByLanguage(data, "en").ctaLinkType === "1" && (
                <td>
                  <TextField
                    value={
                      findArrayElementByLanguage(data, selectedLanguage) &&
                      findArrayElementByLanguage(data, selectedLanguage).ctaLink
                    }
                    onChange={handleChangeCtaLinkTranslated}
                  />
                </td>
              )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Image
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image
                        ? findArrayElementByLanguage(data, "en").image
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDrop}
                    onDropAccepted={sendImage}
                  >
                    {uploadedFile}
                    {fileUpload}
                  </DropZone>
                </div>
              </div>
              <div className="mt-2">
                <Button
                  outline
                  size="slim"
                  destructive
                  onClick={() => handleDeleteImage("image", "en")}
                >
                  Delete Image
                </Button>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage).image
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslated}
                      onDropAccepted={sendImageTranslated}
                    >
                      {uploadedFileTranslated}
                      {fileUploadTranslated}
                    </DropZone>
                  </div>
                </div>
                <div className="mt-2">
                  <Button
                    outline
                    size="slim"
                    destructive
                    onClick={() => handleDeleteImage("image", selectedLanguage)}
                  >
                    Delete Image
                  </Button>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Image Position
              </Text>
            </td>

            <td className="rowDiv">
              <div style={{ width: "100%" }}>
                <Select
                  options={optionsPosition}
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").imagePosition
                  }
                  onChange={handleSelectChangeImagePosition}
                  placeholder="Please select"
                />
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Mobile Image
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").mobileImage
                        ? findArrayElementByLanguage(data, "en").mobileImage
                        : ""
                    }
                    transparent
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropMobile}
                    onDropAccepted={sendImageMobile}
                  >
                    {uploadedFileMobile}
                    {fileUploadMobile}
                  </DropZone>
                </div>
              </div>
              <div className="mt-2">
                <Button
                  outline
                  size="slim"
                  destructive
                  onClick={() => handleDeleteImageMobile("mobile_image", "en")}
                >
                  Delete Image
                </Button>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .mobileImage
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .mobileImage
                          : ""
                      }
                      transparent
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropTranslatedMobile}
                      onDropAccepted={sendImageTranslatedMobile}
                    >
                      {uploadedFileTranslatedMobile}
                      {fileUploadTranslatedMobile}
                    </DropZone>
                  </div>
                </div>
                <div className="mt-2">
                  <Button
                    outline
                    size="slim"
                    destructive
                    onClick={() =>
                      handleDeleteImageMobile("mobile_image", selectedLanguage)
                    }
                  >
                    Delete Image
                  </Button>
                </div>
              </td>
            )}
          </tr>

          {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Image Position
              </Text>
            </td>

            <td className="rowDiv">
              <div style={{ width: "100%" }}>
                <Select
                  options={optionsPosition}
                  value={
                    findArrayElementByLanguage(data, "en") &&
                    findArrayElementByLanguage(data, "en").imagePosition
                  }
                  onChange={handleSelectChangeImagePosition}
                  placeholder="Please select"
                />
              </div>
            </td>
          </tr> */}

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Mp4
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_mp4
                }
                onChange={handleChangeLinkMp4}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_mp4
                  }
                  onChange={handleChangeLinkMp4Translated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Mp4
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_mp4
                        ? findArrayElementByLanguage(data, "en").image_mp4
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".mp4"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropMp4}
                    onDropAccepted={sendFileMp4}
                  >
                    {uploadedFileMp4}
                    {fileUploadMp4}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_mp4
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_mp4
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".mp4"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropMp4Translated}
                      onDropAccepted={sendFileMp4Translated}
                    >
                      {uploadedFileMp4Translated}
                      {fileUploadMp4Translated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Ogg
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_ogg
                }
                onChange={handleChangeLinkOgg}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_ogg
                  }
                  onChange={handleChangeLinkOggTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Ogg
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_ogg
                        ? findArrayElementByLanguage(data, "en").image_ogg
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".ogg"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropOgg}
                    onDropAccepted={sendFileOgg}
                  >
                    {uploadedFileOgg}
                    {fileUploadOgg}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_ogg
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_ogg
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".ogg"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropOggTranslated}
                      onDropAccepted={sendFileOggTranslated}
                    >
                      {uploadedFileOggTranslated}
                      {fileUploadOggTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Link Webm
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").link_webm
                }
                onChange={handleChangeLinkWebm}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).link_webm
                  }
                  onChange={handleChangeLinkWebmTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Video Webm
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_webm
                        ? findArrayElementByLanguage(data, "en").image_webm
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".webm"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropWebm}
                    onDropAccepted={sendFileWebm}
                  >
                    {uploadedFileWebm}
                    {fileUploadWebm}
                  </DropZone>
                </div>
              </div>
            </td>
            {translatedButtonClicked && (
              <td>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={
                        findArrayElementByLanguage(data, selectedLanguage) &&
                        findArrayElementByLanguage(data, selectedLanguage)
                          .image_webm
                          ? findArrayElementByLanguage(data, selectedLanguage)
                              .image_webm
                          : ""
                      }
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      accept=".webm"
                      //   type="file"
                      allowMultiple={false}
                      onDrop={handleDropZoneDropWebmTranslated}
                      onDropAccepted={sendFileWebmTranslated}
                    >
                      {uploadedFileWebmTranslated}
                      {fileUploadWebmTranslated}
                    </DropZone>
                  </div>
                </div>
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Vimeo Id
              </Text>
            </td>
            <td>
              <TextField
                value={
                  findArrayElementByLanguage(data, "en") &&
                  findArrayElementByLanguage(data, "en").vimeo_id
                }
                onChange={handleChangeVimeoId}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={
                    findArrayElementByLanguage(data, selectedLanguage) &&
                    findArrayElementByLanguage(data, selectedLanguage).vimeo_id
                  }
                  onChange={handleChangeVimeoIdranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                PDF File
              </Text>
            </td>
            <td>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                }}
              >
                <div style={{ float: "left" }}>
                  <Thumbnail
                    size="large"
                    source={
                      findArrayElementByLanguage(data, "en") &&
                      findArrayElementByLanguage(data, "en").image_filepdf
                        ? findArrayElementByLanguage(data, "en").image_filepdf
                        : ""
                    }
                  />
                </div>
                <div
                  style={{
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  <DropZone
                    accept=".pdf"
                    //   type="file"
                    allowMultiple={false}
                    onDrop={handleDropZoneDropFilePdf}
                    onDropAccepted={sendFilePdf}
                  >
                    {uploadedFilePdf}
                    {fileUploadPdf}
                  </DropZone>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {/* <Text variant="bodyMd" as="p" fontWeight="medium">
        Image
      </Text>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <div style={{ float: "left" }}>
          <Thumbnail
            size="large"
            source={
              findArrayElementByLanguage(data, "en")
                ? findArrayElementByLanguage(data, "en").image
                : ""
            }
          />
        </div>
        <div
          style={{
            width: "100%",
            marginLeft: "10px",
          }}
        >
          <DropZone
            accept=".png,.jpeg,.jpg,.svg,.json"
            //   type="file"
            allowMultiple={false}
            onDrop={handleDropZoneDrop}
            onDropAccepted={sendImage}
          >
            {uploadedFile}
            {fileUpload}
          </DropZone>
        </div>
      </div> */}
      <Checkbox
        label="Is Active"
        checked={
          findArrayElementByLanguage(data, "en") &&
          findArrayElementByLanguage(data, "en").active
        }
        onChange={handleChange}
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Image"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this image?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </FormLayout>
  );

  function findArrayElementByLanguage(array, language) {
    return array.find((element, index) => {
      return element.language === language;
    });
  }
});
export default ListItemEdit;
